import { motion, AnimatePresence } from 'framer-motion'
import { FileText, ShoppingBag, HelpCircle, ExternalLink } from 'lucide-react'
import type { EvidenceItem } from '@/lib/supportApi'

const SOURCE_ICONS: Record<string, React.ReactNode> = {
  kb_article: <FileText className="h-3 w-3" />,
  hotmart: <ShoppingBag className="h-3 w-3" />,
  faq: <HelpCircle className="h-3 w-3" />,
}

interface EvidencePanelProps {
  sources: EvidenceItem[]
}

export function EvidencePanel({ sources }: EvidencePanelProps) {
  if (sources.length === 0) return null

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        className="ml-9 space-y-1.5"
      >
        <p className="text-[11px] text-muted-foreground font-medium uppercase tracking-wide">
          Fontes consultadas
        </p>
        {sources.map((source, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, x: -4 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: idx * 0.05 }}
            className="flex items-start gap-2 rounded-lg border border-border/50 px-3 py-2"
          >
            <div className="mt-0.5 text-muted-foreground shrink-0">
              {SOURCE_ICONS[source.sourceType] ?? <FileText className="h-3 w-3" />}
            </div>
            <div className="flex-1 min-w-0">
              {source.title && (
                <p className="text-xs font-medium text-foreground truncate">
                  {source.title}
                </p>
              )}
              {source.snippet && (
                <p className="text-[11px] text-muted-foreground line-clamp-2 mt-0.5">
                  {source.snippet}
                </p>
              )}
            </div>
            {source.url && (
              <a
                href={source.url}
                target="_blank"
                rel="noreferrer"
                className="shrink-0 text-muted-foreground hover:text-foreground transition-colors"
              >
                <ExternalLink className="h-3 w-3" />
              </a>
            )}
          </motion.div>
        ))}
      </motion.div>
    </AnimatePresence>
  )
}
